import { render, staticRenderFns } from "./card-with-table-compare.vue?vue&type=template&id=006cf4c0&scoped=true&"
import script from "./card-with-table-compare.vue?vue&type=script&lang=js&"
export * from "./card-with-table-compare.vue?vue&type=script&lang=js&"
import style0 from "./card-with-table-compare.vue?vue&type=style&index=0&id=006cf4c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006cf4c0",
  null
  
)

export default component.exports